module.exports = __webpack_public_path__ + "img/icon-ai-generated-plate.2250ca44.png";